import { Outlet } from "react-router-dom"

export const Layout = () => {
    return(
        <main className="app">
            <Outlet/>
        </main>
    )
}